/**
 * @module views\psm\batch
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch, Prop } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { TreeNode } from "element-ui/types/tree";
import GhDialog from "@/components/ghDialog/ghDialog";
import GhTable from "./../../../components/ghTable/ghTable";
import SiteComponent from "@/businessComponents/mdl/siteComponent/siteComponent";
import GhInvoke from "@/components/ghInvoke/ghInvoke";
import CascaderSite from "@/businessComponents/mdl/cascaderSite/cascaderSite";

@Component({
  components: {
    CascaderSite
  }
})
export default class Batch extends GhBase {
  // 作业数据查询条件
  private argsQuery = {
    startdate: "",
    enddate: "",
    structure_ids: new Array(),
    keywords: ""
  };

  private siteChange(site) {
    this.argsQueryArea.parent_id = site;
    let inv = this.$refs.invoke as GhInvoke;
    inv.invoke();
  }

  private chnageStruct(struct) {
    // this.argsQuery.structure_ids = struct;
    // let que = this.$refs.table as GhTablePage;
    // que.query(this.argsQuery);
  }

  // 车间数据查询条件
  private argsQueryArea = { parent_id: "", function: "生产" };

  private activatedTab = 0;
  // private draw = true;

  // activated() {
  //   this.draw = false;
  //   this.$nextTick(() => {
  //     this.draw = true;
  //   });
  // }

  private argsQueryBom = { version_id: "1000005022", keywords: "" };

  private tabs: IGhTab[] = [
    { title: "作业维护", drawer: false },
    { title: "配方查看", drawer: false },
    { title: "工艺查看", drawer: false }
  ];

  // 作业状态
  private states = {};
  private statesLock = {};

  // 配料状态
  private mixStates = {};

  // 生产车间
  private structures = {};

  // 产品数据
  private materials = {};
  private matLoading = false;

  // 当前选中的批次数据
  private currentModel = {};

  // 新增数据模板
  private templateModel = {
    BatchStateId: "19a500b1f4785deb141a00000c",
    BatchStateName: "新建",
    MeasureId: "5c988c09785deb1e84b47f31",
    MeasureName: "Kg"
  };

  created() {
    this.get_states();
    this.get_materials();
    this.get_mixStates();
  }
  mounted() {}

  // 获取作业状态数据
  private get_states() {
    this.$Api
      .invoke({
        moduleName: "mes.business.psm.batch.service",
        className: "BatchStateService",
        method: "get_dict",
        args: {}
      })
      .then(res => {
        this.states = res.data.data[0];
        this.statesLock = res.data.data[1];
      })
      .finally(() => {});
  }

  // 获取配料状态数据
  private get_mixStates() {
    this.$Api
      .invoke({
        moduleName: "mes.business.psm.mix.service",
        className: "MixStateService",
        method: "get_dict",
        args: {}
      })
      .then(res => {
        this.mixStates = res.data.data;
      })
      .finally(() => {});
  }

  // 获取产品数据
  private get_materials() {
    this.matLoading = true;
    this.$Api
      .invoke({
        moduleName: "mes.business.mdl.material.service",
        className: "MaterialService",
        method: "get_data_by_purchase",
        args: { fields: ["Id", "Ctrl", "Name", "Cd"] }
      })
      .then(res => {
        this.materials = res.data.data;
        // console.log(this.materials);
      })
      .finally(() => {
        this.matLoading = false;
      });
  }

  // 移到前一天
  private move_pre_day(item: IndexObject) {
    this.$setLoading(true);
    this.$Api
      .invoke({
        moduleName: "mes.business.psm.batch.service",
        className: "BatchService",
        method: "move_pre_day",
        args: { id: item.Id }
      })
      .then(() => {
        let table = this.$refs.table as GhTablePage;
        table.query(this.argsQuery);
      })
      .finally(() => {
        this.$setLoading(false);
      });
  }

  // 移到后一天
  private move_next_day(item: IndexObject) {
    this.$setLoading(true);
    this.$Api
      .invoke({
        moduleName: "mes.business.psm.batch.service",
        className: "BatchService",
        method: "move_next_day",
        args: { id: item.Id }
      })
      .then(() => {
        let table = this.$refs.table as GhTablePage;
        table.query(this.argsQuery);
      })
      .finally(() => {
        this.$setLoading(false);
      });
  }

  // 查看配方
  private bom_view(item: IndexObject) {
    this.currentModel = item;
    this.argsQueryBom.version_id = item.Bom;
    this.activatedTab = 1;
    let bomTable = this.$refs.tableBom as GhTablePage;
    bomTable.query(this.argsQueryBom);
  }

  // 查看工艺
  private routing_view(item: IndexObject) {
    this.currentModel = item;
    this.activatedTab = 2;
  }
  // created() {
  // let  time=new Date();
  // let year=time.getFullYear();
  // let month=time.getMonth()+1;
  // let date=time.getDate();
  // let seperator="-";
  // let today=year+seperator+month+seperator+date;
  // this.argsQuery.startdate=today;
  // this.argsQuery.enddate=today;

  // }

  // 选择工厂变化时加载车间及作业数据
  @Watch("argsQueryArea.parent_id")
  private areaChanged() {
    this.argsQuery.structure_ids = new Array();
    this.argsQuery.structure_ids.push(this.argsQueryArea.parent_id);
    let table = this.$refs.table as GhTablePage;
    table.query(this.argsQuery);
  }

  // 车间勾选变化时自动查询作业数据
  private checkChanged(item: IndexObject) {
    if (item.Checked) {
      if (this.argsQuery.structure_ids.indexOf(item.Id) === -1) {
        this.argsQuery.structure_ids.push(item.Id);
      }
      let index = this.argsQuery.structure_ids.indexOf(
        this.argsQueryArea.parent_id
      );
      if (index > -1) {
        this.argsQuery.structure_ids.splice(index, 1);
      }
    } else {
      let index = this.argsQuery.structure_ids.indexOf(item.Id);
      if (index > -1) {
        this.argsQuery.structure_ids.splice(index, 1);
      }
    }
    if (this.argsQuery.structure_ids.length === 0) {
      this.argsQuery.structure_ids.push(this.argsQueryArea.parent_id);
    }
    let table = this.$refs.table as GhTablePage;
    table.query(this.argsQuery);
  }

  // 保存作业数据之前
  private beforeSave(item: IndexObject) {
    if (item.StructureId.Id) {
      let structure = item.StructureId;
      item.StructureId = structure.Id;
      item.StructureName = structure.Name;
    }
    if (item.MaterialId.Id) {
      let mat = item.MaterialId;
      item.MaterialId = mat.Id;
      item.MaterialName = mat.Name;
      item.MaterialCd = mat.Cd;
      item.MaterialCtrl = mat.Ctrl;
    }
    item.PlanQty = parseInt(item.PlanQty, 10);
  }
}
